@if ({}; as STATE) {
  <section class="login-page">
    <auth-wrapper [title]="title" [description]="description">
      <login-form></login-form>
    </auth-wrapper>
  </section>
}
